import React from 'react';
import sleep from '../../utils/sleep';
import './HomeIntro.css';
import socialNetwork from '../../utils/socialNetworkingLinks';

export default class Content extends React.Component {
  constructor(props) {
    super(props);
    this.intro = React.createRef();
  }

  typeAnimation = () => {
    const intro = this.intro.current;
    let index = 0;
    const text = intro.textContent;
    
    intro.style.height = intro.offsetHeight+50+"px";
    intro.textContent = "";
     
    sleep(1000)
    .then(() => {
      const type =setInterval(() => {
        intro.textContent += text.charAt(index);
        index++;
        if(index >= text.length) {
          clearInterval(type);
        }
      }, 200);
    })
  }

  componentDidMount() {
    this.typeAnimation();
  }

  render() {
    return ( 
      <div className="home-content-intro">
        <div className="intro" ref={this.intro}>
          Hi there! I am Tielin Li, a full-stack software developer.
        </div>

        <div className="intro-contact">
          <span>Github: <a href={socialNetwork.gitHub} target="_blank" rel="noreferrer" >ltlkong</a></span>
          <span>LinkedIn: <a href={socialNetwork.linkedIn} target="_blank" rel="noreferrer" >Tielin Li</a></span>        
        </div>
      </div>
    )
  }
}